import Grid from "@mui/material/Grid";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import { SupportCenterContent } from "./SupportCenterContent";
// Images
import empty from "@/assets/images/commons/empty.png";
import emptyTable from "@/assets/images/commons/empty_table.png";
import { IPayrollClosingSideBarSelected } from "@/Washouts/types/PayrollClosing/PayrollClosingSideBar";

interface ISupportCenterContainerProps {
	selectedItem: IPayrollClosingSideBarSelected | null;
	selection: boolean;
}

export const SupportCenterContainer = (props: Readonly<ISupportCenterContainerProps>) => {
	if (!props?.selectedItem) {
		return (
			<RoundedBox>
				<EmptyBody
					image={props.selection ? emptyTable : empty}
					title="No item selected"
					bodyHeight="510px"
					className="!shadow-none"
				/>
			</RoundedBox>
		);
	}

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<RoundedBox className="!px-[28px] !py-[30px]">
					<SupportCenterContent selectedItem={props.selectedItem || ""} />
				</RoundedBox>
			</Grid>
		</Grid>
	);
};
